<div class="modal-header">
    <button class="close" type="button" mat-dialog-close aria-label="Close" ><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">Transfer Transaction Confirmation</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    This will unassign you from this transaction and move it to the {{businessUnitName}} business unit
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" (click)="cancel()" [disabled]="transferringTransaction">Cancel</button>
        <mvm-spinner-btn [btnText]="'Transfer'" [isLoading]="transferringTransaction" (clicked)="confirm()"></mvm-spinner-btn>
    </div>
</div>